// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PriceRangeCriteria = require("./PriceRangeCriteria.bs.js");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let BuyerNeedPriceRange_buyerNeedV5_graphql = require("../../__generated__/BuyerNeedPriceRange_buyerNeedV5_graphql.bs.js");

let convertFragment = BuyerNeedPriceRange_buyerNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerNeedPriceRange_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerNeedPriceRange_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, BuyerNeedPriceRange_buyerNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BuyerNeedPriceRange_buyerNeedV5_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function BuyerNeedPriceRange(props) {
  let buyerNeed = RescriptRelay_Fragment.useFragment(BuyerNeedPriceRange_buyerNeedV5_graphql.node, convertFragment, props.buyerNeed);
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "price range",
    children: JsxRuntime.jsx(PriceRangeCriteria.make, {
      priceRange: buyerNeed.priceRange.fragmentRefs,
      priceType: "oneTime",
      size: props.size
    })
  });
}

let make = BuyerNeedPriceRange;

exports.Fragment = Fragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
